import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class SecurityRecommendations extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                        <article class="docs-article" id="section-1">

                            <h1 class="docs-heading">
                                Security Recommendations
                            </h1>

                            <section class="docs-intro">

                                <p>
                                    Partners must follow the security practices below to ensure safe
                                    and compliant API integration.
                                </p>

                            </section>

                        </article>
                        <article class="docs-article">

                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Authentication Security
                                </h2>

                                <ul>

                                    <li>
                                        Always use <b>HTTPS</b> for all API communication.
                                    </li>

                                    <li>
                                        Never expose Secret Keys in client-side code or public
                                        repositories.
                                    </li>

                                    <li>
                                        Rotate API credentials every <b>90 days</b> or
                                        immediately upon suspected compromise.
                                    </li>

                                    <li>
                                        Restrict API access to approved IP addresses and trusted
                                        systems only.
                                    </li>

                                </ul>

                            </section>

                        </article>
                            
                        <article class="docs-article">

                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Request Security
                                </h2>

                                <ul>

                                    <li>
                                        Generate a unique <code>nonce</code> for every request. The
                                        nonce must be exactly <b>32 characters</b>.
                                    </li>

                                    <li>
                                        Do not reuse HMAC signatures across requests.
                                    </li>

                                    <li>
                                        Validate request timestamps to prevent replay attacks.
                                    </li>

                                    <li>
                                        Reject duplicate requests based on the <code>nonce</code> to
                                        prevent duplicate transactions.
                                    </li>

                                </ul>

                            </section>

                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-get-trans-details"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Get Transaction Details
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-complete-trans"
                                            >
                                                Complete Transaction Flow&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}